import dayjs from "dayjs"
import duration from "dayjs/plugin/duration"

dayjs.extend(duration)

export const getFormattedTime = (timestamp: Date | undefined) => {
    const timeZone = localStorage.getItem("siteTimezone") ?? "UTC"
    if (!timestamp) return
    return new Date(timestamp).toLocaleTimeString("en-GB", {
        timeZone,
        hour12: true, // 12-hour format
    })
}
// Format time to HH:MM:SS
export const formatTime = (timeInSeconds: number) => {
    const timeDuration = dayjs.duration(timeInSeconds, "seconds")
    return timeDuration.format("HH:mm:ss")
}
